module.exports = __webpack_public_path__ + "../resources/img/bg_load1_02.da7679ac.png";